// @ts-strict-ignore
import { IconButton } from '@components/rolex-ui/IconButton'
import { cn } from '@lib/cn'
import { useRolexEventTracking } from '@lib/hooks/use-rolex-track-events'
import { useTranslation } from 'next-i18next'
import { FC } from 'react'

interface Props {
  isHorizontal?: boolean
  sendMessage?: boolean
  findStore?: boolean
  phoneNumber?: string
  directionsUrl?: string
  detailSlug?: string
  className?: string
  showLabel?: boolean
}

const CtaButtons: FC<Props> = ({
  isHorizontal = false,
  sendMessage = false,
  findStore = false,
  phoneNumber,
  directionsUrl,
  detailSlug,
  className,
  showLabel = true,
}) => {
  const {
    t,
    i18n: { language },
  } = useTranslation('rolex')
  const { track } = useRolexEventTracking()

  const handleDirectionsClick = (e, href: string) => {
    e.preventDefault()
    track('getDirections')
    window.open(href, '_blank')
  }

  const handlePhoneClick = (e, href: string) => {
    e.preventDefault()
    track('contactCall')
    window.location.href = href
  }

  const handleFindStoreClick = (e) => {
    e.preventDefault()
    track('findStore')
    window.location.href = `/${language}/rolex/contact`
  }

  const handleGoToMessageModule = (e) => {
    e.preventDefault()
    const messageEl = document.getElementById('message-module')
    if (messageEl && messageEl.offsetTop) {
      window.scrollTo({ top: messageEl.offsetTop - 80, left: 0, behavior: 'smooth' })
    } else {
      window.location.href = `/rolex/${t('rolex.sendAMessage', { ns: 'navigation' })}`
    }
  }

  return (
    <ul
      className={cn(
        'flex flex-row justify-center gap-3',
        isHorizontal && 'md:justify-evenly',
        !isHorizontal && 'md:flex-col',
        className,
      )}
    >
      {phoneNumber && (
        <IconButton
          onClick={(e) => handlePhoneClick(e, `tel:+31206225333`)}
          variant="light"
          icon="phone"
          as="button"
          label={showLabel && `${t('cta.call')} ${phoneNumber}`}
        />
      )}
      {sendMessage && (
        <IconButton
          onClick={(e) => handleGoToMessageModule(e)}
          variant="light"
          icon="mail"
          as="button"
          label={showLabel && t('cta.message')}
        />
      )}
      {findStore && (
        <IconButton
          onClick={(e) => handleFindStoreClick(e)}
          variant="light"
          icon="location"
          as="button"
          label={showLabel && t('cta.store')}
        />
      )}
      {directionsUrl && (
        <IconButton
          onClick={(e) => handleDirectionsClick(e, directionsUrl)}
          variant="light"
          icon="directions"
          as="button"
          label={showLabel && t('cta.getDirections')}
        />
      )}
      {detailSlug && (
        <IconButton
          href={`/rolex/contact/${detailSlug}`}
          variant="light"
          icon="plus"
          as="link"
          label={showLabel && t('cta.moreDetails')}
        />
      )}
    </ul>
  )
}

export default CtaButtons
